
import { WorldCountry } from '../types';

export const moroccoExpanded2: WorldCountry = {
  code: 'MA',
  name: 'Morocco',
  slug: 'morocco',
  population: 37076584,
  topCities: [
    // Ciudades principales existentes
    { name: 'Casablanca', slug: 'casablanca', population: 3359818 },
    { name: 'Rabat', slug: 'rabat', population: 1847000 },
    { name: 'Fez', slug: 'fez', population: 1225000 },
    { name: 'Marrakech', slug: 'marrakech', population: 928850 },
    { name: 'Agadir', slug: 'agadir', population: 678596 },
    { name: 'Tangier', slug: 'tangier', population: 1065601 },
    { name: 'Meknes', slug: 'meknes', population: 632079 },
    { name: 'Oujda', slug: 'oujda', population: 558000 },
    { name: 'Kenitra', slug: 'kenitra', population: 500000 },
    { name: 'Tetouan', slug: 'tetouan', population: 463968 },
    
    // Nuevas ciudades - Expansión Fase 9
    { name: 'Safi', slug: 'safi', population: 450000 },
    { name: 'Temara', slug: 'temara', population: 440000 },
    { name: 'Mohammedia', slug: 'mohammedia', population: 430000 },
    { name: 'Khouribga', slug: 'khouribga', population: 420000 },
    { name: 'El Jadida', slug: 'el-jadida', population: 410000 },
    { name: 'Beni Mellal', slug: 'beni-mellal', population: 400000 },
    { name: 'Nador', slug: 'nador', population: 390000 },
    { name: 'Taza', slug: 'taza', population: 380000 },
    { name: 'Settat', slug: 'settat', population: 370000 },
    { name: 'Berrechid', slug: 'berrechid', population: 360000 },
    { name: 'Khemisset', slug: 'khemisset', population: 350000 },
    { name: 'Inezgane', slug: 'inezgane', population: 340000 },
    { name: 'Ksar el Kebir', slug: 'ksar-el-kebir', population: 330000 },
    { name: 'Larache', slug: 'larache', population: 320000 },
    { name: 'Guelmim', slug: 'guelmim', population: 310000 },
    { name: 'Errachidia', slug: 'errachidia', population: 300000 },
    { name: 'Ait Melloul', slug: 'ait-melloul', population: 290000 },
    { name: 'Dcheira El Jihadia', slug: 'dcheira-el-jihadia', population: 280000 },
    { name: 'Ouarzazate', slug: 'ouarzazate', population: 270000 },
    { name: 'Tiznit', slug: 'tiznit', population: 260000 },
    { name: 'Al Hoceima', slug: 'al-hoceima', population: 250000 },
    { name: 'Taroudant', slug: 'taroudant', population: 240000 },
    { name: 'Essaouira', slug: 'essaouira', population: 230000 },
    { name: 'Tan-Tan', slug: 'tan-tan', population: 220000 },
    { name: 'Fnideq', slug: 'fnideq', population: 210000 },
    { name: 'Sidi Kacem', slug: 'sidi-kacem', population: 200000 },
    { name: 'Sidi Slimane', slug: 'sidi-slimane', population: 190000 },
    { name: 'Azrou', slug: 'azrou', population: 180000 },
    { name: 'Midelt', slug: 'midelt', population: 170000 },
    { name: 'Ifrane', slug: 'ifrane', population: 160000 },
    { name: 'Chefchaouen', slug: 'chefchaouen', population: 150000 },
    { name: 'Tinghir', slug: 'tinghir', population: 145000 },
    { name: 'Zagora', slug: 'zagora', population: 140000 },
    { name: 'Sefrou', slug: 'sefrou', population: 135000 },
    { name: 'Kelaat Mgouna', slug: 'kelaat-mgouna', population: 130000 },
    { name: 'Boujad', slug: 'boujad', population: 125000 },
    { name: 'Fquih Ben Salah', slug: 'fquih-ben-salah', population: 120000 },
    { name: 'Kasba Tadla', slug: 'kasba-tadla', population: 115000 },
    { name: 'El Kelaa des Sraghna', slug: 'el-kelaa-des-sraghna', population: 110000 },
    { name: 'Ben Guerir', slug: 'ben-guerir', population: 105000 },
    { name: 'Youssoufia', slug: 'youssoufia', population: 100000 },
    { name: 'Jerada', slug: 'jerada', population: 95000 },
    { name: 'Bouarfa', slug: 'bouarfa', population: 90000 },
    { name: 'Taourirt', slug: 'taourirt', population: 85000 },
    { name: 'Berkane', slug: 'berkane', population: 80000 },
    { name: 'Ahfir', slug: 'ahfir', population: 75000 },
    { name: 'Martil', slug: 'martil', population: 70000 },
    { name: 'Mdiq', slug: 'mdiq', population: 65000 },
    { name: 'Cabo Negro', slug: 'cabo-negro', population: 60000 },
    { name: 'Asilah', slug: 'asilah', population: 55000 },
    { name: 'Souk El Arbaa', slug: 'souk-el-arbaa', population: 50000 },
    { name: 'Mechra Bel Ksiri', slug: 'mechra-bel-ksiri', population: 48000 },
    { name: 'Sidi Yahya El Gharb', slug: 'sidi-yahya-el-gharb', population: 46000 },
    { name: 'Moulay Bousselham', slug: 'moulay-bousselham', population: 44000 },
    { name: 'Oualidia', slug: 'oualidia', population: 42000 },
    { name: 'Sidi Bouzid', slug: 'sidi-bouzid', population: 40000 },
    { name: 'Azemmour', slug: 'azemmour', population: 38000 },
    { name: 'Jorf Lasfar', slug: 'jorf-lasfar', population: 36000 },
    { name: 'Bir Jdid', slug: 'bir-jdid', population: 34000 },
    { name: 'Sidi Bennour', slug: 'sidi-bennour', population: 32000 },
    { name: 'Zemamra', slug: 'zemamra', population: 30000 },
    { name: 'Ouled Teima', slug: 'ouled-teima', population: 28000 },
    { name: 'Biougra', slug: 'biougra', population: 26000 },
    { name: 'Massa', slug: 'massa', population: 24000 },
    { name: 'Tafraout', slug: 'tafraout', population: 22000 },
    { name: 'Iguelmin', slug: 'iguelmin', population: 20000 },
    { name: 'Akka', slug: 'akka', population: 19000 },
    { name: 'Foum Zguid', slug: 'foum-zguid', population: 18000 },
    { name: 'Mhamid', slug: 'mhamid', population: 17000 },
    { name: 'Merzouga', slug: 'merzouga', population: 16000 },
    { name: 'Erfoud', slug: 'erfoud', population: 15000 },
    { name: 'Rissani', slug: 'rissani', population: 14000 },
    { name: 'Arfoud', slug: 'arfoud', population: 13000 },
    { name: 'Alnif', slug: 'alnif', population: 12000 },
    { name: 'Tinjdad', slug: 'tinjdad', population: 11000 },
    { name: 'Goulmima', slug: 'goulmima', population: 10000 },
    { name: 'Rich', slug: 'rich', population: 9500 },
    { name: 'Boudnib', slug: 'boudnib', population: 9000 },
    { name: 'Boudenib', slug: 'boudenib', population: 8500 },
    { name: 'Tendrara', slug: 'tendrara', population: 8000 },
    { name: 'Figuig', slug: 'figuig', population: 7500 },
    { name: 'Ich', slug: 'ich', population: 7000 },
    { name: 'Bouanane', slug: 'bouanane', population: 6500 },
    { name: 'Debdou', slug: 'debdou', population: 6000 },
    { name: 'Ain Beni Mathar', slug: 'ain-beni-mathar', population: 5500 },
    { name: 'El Aioun', slug: 'el-aioun', population: 5000 },
    { name: 'Layoune', slug: 'layoune', population: 4800 },
    { name: 'Boujdour', slug: 'boujdour', population: 4600 },
    { name: 'Smara', slug: 'smara', population: 4400 },
    { name: 'Dakhla', slug: 'dakhla', population: 4200 },
    { name: 'Aousserd', slug: 'aousserd', population: 4000 },
    { name: 'Lagouira', slug: 'lagouira', population: 3800 },
    { name: 'Bir Lehlou', slug: 'bir-lehlou', population: 3600 },
    { name: 'Tifariti', slug: 'tifariti', population: 3400 },
    { name: 'Mahbes', slug: 'mahbes', population: 3200 },
    { name: 'Amgala', slug: 'amgala', population: 3000 }
  ]
};
